module.exports = __webpack_public_path__ + "media/site_templates/www.bathroomrenovations.biz/images/our_services_3-94465ad8adbaf7c46aae23dc1dc62f80.jpg";